import { useRef, useEffect } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { RectAreaLightUniformsLib } from "three/examples/jsm/lights/RectAreaLightUniformsLib.js";
import { RectAreaLightHelper } from "three/examples/jsm/helpers/RectAreaLightHelper.js";

export default function Lights() {
  const rectLightRef = useRef();
  const helperRef = useRef();

  // Initialize the uniforms for RectAreaLight
  RectAreaLightUniformsLib.init();

  // Create the helper when the light is up
  useEffect(() => {
    if (rectLightRef.current && helperRef.current) {
      const helper = new RectAreaLightHelper(rectLightRef.current);
      helperRef.current.add(helper);

      return () => {
        helperRef.current?.remove(helper);
      };
    }
  }, []);

  return (
    <>
      <ambientLight intensity={2.5} color="#ffffff" />

      {/* Helper to visualize the RectAreaLight */}
      <group ref={helperRef} />
    </>
  );
}
